import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const Lighting = createSvgIcon(
  <path d="M0 0v2.25h10.875V7.5H8.933L3 13.01v5.74h4.5v.75a4.5 4.5 0 1 0 9 0v-.75H21v-5.74L15.067 7.5h-1.942V2.25H24V0H0Zm14.25 18.75v.75a2.25 2.25 0 0 1-4.5 0v-.75h4.5Zm4.5-2.25H5.25v-2.51l4.567-4.24h4.366l4.567 4.24v2.51Z" />,
  'Lighting'
);

export { Lighting };